import { render, staticRenderFns } from "./character.vue?vue&type=template&id=e19b7eb0&scoped=true&"
import script from "./character.vue?vue&type=script&lang=js&"
export * from "./character.vue?vue&type=script&lang=js&"
import style0 from "./character.vue?vue&type=style&index=0&id=e19b7eb0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19b7eb0",
  null
  
)

export default component.exports